import { ColorPicker as WPColorPicker, Popover, Button, BaseControl, Flex } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { useState, useRef } from '@wordpress/element';

const ColorPicker = ({ field, value, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef();

    const handleReset = () => {
        onChange(field.default_value || '#ffffff'); // Reset to default_value or white
        setIsOpen(false); // Optional: close popover
    };

    return (
        <BaseControl className="component-color-picker" __nextHasNoMarginBottom>
            <Button
                ref={buttonRef}
                onClick={() => setIsOpen(!isOpen)}
                aria-expanded={isOpen}
            >
                <span
                    className="component-color-picker__indicator"
                    style={{
                        backgroundColor: value || field.default_value || '#ffffff',
                    }}
                />
                <label className="components-base-control__label">
                    {field.label}
                </label>
            </Button>

            {isOpen && (
                <Popover
                    position="bottom center"
                    anchorRef={buttonRef}
                    onClose={() => setIsOpen(false)}
                >
                    <div style={{ padding: '10px' }}>
                        <WPColorPicker
                            color={value}
                            onChangeComplete={(newColor) => onChange(newColor.hex)}
                            enableAlpha
                            disableCustomColors={false}
                            defaultPalette
                        />
                        <Flex justify="flex-end" style={{ marginTop: '10px' }}>
                            <Button isSecondary onClick={handleReset}>
                                {__('Reset', 'voxycure-framework')}
                            </Button>
                        </Flex>
                    </div>
                </Popover>
            )}
        </BaseControl>
    );
};

export default ColorPicker;
